export default {
  already_signed_in_msg:
    "You're already signed in, you're required to sign out before signing in again",
};
